import { createActionGroup, emptyProps } from '@ngrx/store';
import { props } from '@ngrx/store';
import {
  ForgotPasswordPayload,
  LogInPayload,
  patchPasswordPayload,
  ResetPasswordPayload,
  SignUpPayload,
} from '@core/models/entities/auth.models';

const PREFIX = '[Auth API]';

export const AuthActions = createActionGroup({
  source: `${PREFIX} Root`,
  events: {
    checkEmail: props<{ email: string }>(),
    saveEmailResult: props<{ existing_user: boolean; company: string; email: string }>(),
    saveEmail: props<{ email: string }>(),
    signUp: props<SignUpPayload>(),
    signIn: props<LogInPayload>(),
    signInFailure: props<{ error: string }>(),
    forgotPassword: props<ForgotPasswordPayload>(),
    forgotPasswordSuccess: props<{ success: boolean }>(),
    forgotPasswordFailure: props<{ error: string }>(),
    cleanForgotPassword: emptyProps(),
    resetPassword: props<ResetPasswordPayload>(),
    resetPasswordSuccess: props<{ success: boolean }>(),
    resetPasswordFailure: props<{ error: string }>(),
    patchPasswordUser: props<patchPasswordPayload>(),
    navigateToProfile: emptyProps(),
    navigateToOnDemand: emptyProps(),
    setPendingPartnerSubscriptionOfferAfterSignUp: props<{ pending: boolean }>(),
    setToken: props<{ token: string }>(),
    error: props<{ error: string }>(),
    logout: emptyProps(),
  },
});
